import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as _ from 'underscore';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ContactNewComponent } from '../contact-new/contact-new.component';
import { UntypedFormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { DataService } from 'src/app/shared/services/data.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import {
  DropdownContactTitleDTO,
  DropdownContactTypeDTO,
  DropdownLanguage,
  LocalityDto,
  LowInformationsParams,
  RechercheContactsParams,
} from 'src/app/shared/interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { LanguagesService } from 'src/app/shared/services/languages.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { catchError, map } from 'rxjs/operators';
import { AddressesService } from 'src/app/shared/services/addresses.service';
import { NationalitiesService } from 'src/app/shared/services/nationalities.service';
import { groupBy, uniq } from 'underscore';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { MeService } from 'src/app/shared/services/me.service';
import { StreetByCountryIAddressDTO } from 'src/app/shared/interfaces/addresses/dtos/street-by-country-dto.interface';
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig],
})
export class ContactsComponent implements OnInit, OnDestroy {
  public titleButtons: IButton[] = [
    {
      text: 'homeCourrier.buttons.create',
      styleClass: 'green',
      icon: 'bi bi-plus',
      iconPosition: 'left',
      id: 'contactButtonAdd',
      click: (): void => this.onCreate(),
    },
  ];

  public editMode: boolean;
  public contacts: Contact[] = [];
  public contact: Contact = null;
  public contactsTypes: DropdownContactTypeDTO[];

  public sMembers: Contact[] = []; // society members
  public fullSearch: boolean = false;
  public button = [
    {
      text: 'Enregistrer',
      background: 'rgb(96, 205, 255)',
      color: 'white',
      skin: 'super-compos-secondary-btn',
    },
  ];
  // Filters
  public typeContact: string;
  public typeSociete: string;
  public allcontacts: Contact[] = [];
  public typeContactLV: { label: string; value: string }[] = [
    { label: 'Personne morale', value: 'oui' },
    { label: 'Personne physique', value: 'non' },
  ];
  public openSearchModal: boolean = false;
  public formSearch = new UntypedFormGroup({
    nom: new FormControl<string>(null),
    prenom: new FormControl<string>(null),
    tva: new FormControl<string>(null),
    titre: new FormControl<string>(null),
    nationalite: new FormControl<string>(null),
    langueID: new FormControl<number>(null),
    cp: new FormControl<string>(null),
    rue: new FormControl<string>(null),
    streetNumber: new FormControl<string>(null),
    localite: new FormControl<string>(null),
    email: new FormControl<string>(null),
    gsm: new FormControl<string>(null),
    contactTypeId: new FormControl<number>(null),
  });
  public postalCodesList: { label: string; value: string }[] = [];
  public langues: DropdownLanguage[] = [];
  public contactTitles: DropdownContactTitleDTO[] = [];
  public nationalites: { label: string; value: string }[] = [];
  public searchObject: {
    nom: string;
    prenom: string;
    titre: string;
    tva: string;
    nationalite: string;
    langueID: number;
    email: string;
    gsm: string;
    cp: string;
    rue: string;
    localite: string;
    contactTypeId: number;
  };
  public active: boolean = true;
  public searchString: string = '';
  public contactsBACKUP: Contact[] = [];
  public noResults: boolean = false;
  public reloadSubscription: Subscription;
  public pageNumber: number = 1;
  public searchLoaded: boolean = true;
  public isSearchMode: boolean; // if true scroll event is disabled
  public params: RechercheContactsParams & LowInformationsParams = {
    pageNumber: 1,
    pageSize: 2000,
    sortFields: 'nom',
  };
  public clientType = sessionStorage.getItem('clientType');

  public localities: { [localityName: string]: string[] } = {};
  public localitiesLV: { label: string; value: string }[] = [];
  public postalCodes: string[] = [];
  public postalCodesLV: { label: string; value: string }[] = [];
  public streets: StreetByCountryIAddressDTO[] = [];
  public streetsLV: { label: string; value: string }[] = [];
  public streetNumbers: { boxNumber: string; houseNumber: string; streetId: number }[] = [];
  public streetNumbersLV: { label: string; value: string }[] = [];
  public streetNumbersLoading: boolean = false;

  public triggerSearch: boolean = false;
  constructor(
    private titleService: Title,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    public router: Router,
    private dataService: DataService,
    private cd: ChangeDetectorRef,
    private dialogService: DialogService,
    private translater: TranslateService,
    private langsService: LanguagesService,
    private contactsService: ContactsService,
    private addressesService: AddressesService,
    private nationalitiesService: NationalitiesService,
    private contactsGlobalService: ContactsGlobalService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.setDatas();
  }

  private setDatas(): void {
    this.dataService.setSidebarSmall(true);
    this.reloadSubscription = this.dataService.reloadContactBool.subscribe({
      next: (reload) => {
        if (reload) {
          this.triggerSearch = true;
          if (Object.keys(this.formSearch.value).some((k) => this.formSearch.value[k] !== null)) {
            this.searchAdvanced();
          } else {
            this.getContacts({ pageNumber: 1, pageSize: 2000, sortFields: 'nom' });
          }
        }
      },
    });
    this.setTranslations();

    forkJoin({
      typesContacts: this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des types de contacts');
          return of([]);
        })
      ),
      postalCodes: this.contactsService.getPostalCodesByCountry(1).pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des codes postaux');
          return of([]);
        })
      ),
      langs: this.langsService.fetchMappedLanguagesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des langues');
          return of([]);
        })
      ),
      localities: this.addressesService.fetchLocalities().pipe(
        map((res: LocalityDto[]) => {
          const groupedByLocality = groupBy(res, 'nameFr');
          Object.keys(groupedByLocality).forEach((localityName: string) => {
            groupedByLocality[localityName] = (groupedByLocality[localityName] as LocalityDto[]).map((locality) => locality.postalcode);
          });

          return groupedByLocality;
        }),
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des localités');
          return of({});
        })
      ),
      titles: this.contactsGlobalService.fetchMappedContactTitlesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des titres');
          return of([]);
        })
      ),
      nationalites: this.nationalitiesService.fetchNationalities().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des nationalités');
          return of([]);
        })
      ),
    }).subscribe((value) => {
      this.contactsTypes = value.typesContacts;
      value.postalCodes.forEach((postalCode) => {
        this.postalCodesList.push({ label: postalCode.codePostal, value: postalCode.codePostal });
      });
      this.langues = value.langs;
      this.formatLocalities(value.localities);

      this.contactTitles = value.titles;
      this.formatNationalities(value.nationalites);
      this.getContacts({ pageNumber: 1, pageSize: 2000, sortFields: 'nom' });
    });
  }

  private setTranslations(): void {
    this.titleService.setTitle(this.translater.translate('tabsTitle.contacts'));
    this.titleButtons = this.titleButtons.map((btn) => ({ ...btn, text: this.translater.translate(btn.text) }));
  }

  private formatLocalities(localities): void {
    this.localities = localities;
    this.localitiesLV = Object.keys(this.localities).map((localityName: string) => ({
      label: localityName,
      value: localityName,
    }));
  }

  private formatNationalities(nationalities: string[]): void {
    nationalities.forEach((nationality) => {
      this.nationalites.push({ label: nationality, value: nationality });
    });
    this.nationalites = _.sortBy(this.nationalites, 'label');
  }

  ngOnDestroy(): void {
    this.reloadSubscription.unsubscribe();
  }

  public onSelectLocality(event: { originalEvent: PointerEvent; value: string }): void {
    if (!event.value) {
      this.formSearch.patchValue({ locality: null });
      this.formSearch.patchValue({ cp: null });
      this.formSearch.patchValue({ rue: null });

      return;
    }

    const selectedLocality: string | undefined = Object.keys(this.localities).find((localityName: string) => localityName === event.value);
    this.formSearch.patchValue({ locality: selectedLocality });

    if (selectedLocality) {
      this.postalCodes = this.localities[selectedLocality];
      this.postalCodesLV = this.postalCodes.map((postalCode: string) => ({ label: postalCode, value: postalCode }));

      if (this.postalCodes.length === 1) {
        this.formSearch.patchValue({ cp: this.postalCodes[0] });
        this.fetchLocalityStreets(this.postalCodes);
      }
    }
  }

  public onSelectPostalCode(event: { originalEvent: PointerEvent; value: string }): void {
    if (!event.value) {
      this.formSearch.patchValue({ cp: null });
      this.formSearch.patchValue({ rue: null });
      return;
    }

    this.formSearch.patchValue({ cp: event.value });
    this.fetchLocalityStreets(this.postalCodes);
  }

  public onSelectStreet(event: { originalEvent: PointerEvent; value: string }): void {
    if (!event.value) {
      this.formSearch.patchValue({ rue: null });
      return;
    }

    const selectedStreet: StreetByCountryIAddressDTO | undefined = this.streets.find((street) => street.id === event.value);

    if (selectedStreet) {
      this.formSearch.patchValue({ rue: selectedStreet.nameFr });
      this.fetchStreetNumbers(selectedStreet.id);
    }
  }

  private fetchLocalityStreets(postalCodes: string[]): void {
    this.addressesService.fetchLocalityStreets(postalCodes).subscribe({
      next: (localityStreets: StreetByCountryIAddressDTO[]) => {
        this.streets = localityStreets;
        this.streetsLV = this.streets.map((street: StreetByCountryIAddressDTO) => ({ label: street.nameFr, value: street.id }));
      },
    });
  }

  private fetchStreetNumbers(streetId: string): void {
    this.streetNumbersLoading = true;
    this.addressesService.fetchStreetNumbers(streetId).subscribe({
      next: (streetNumbers: { boxNumber: string; houseNumber: string; streetId: number }[]) => {
        this.streetNumbers = streetNumbers;

        this.streetNumbersLV = uniq(streetNumbers, 'houseNumber').map(
          (streetNumber: { boxNumber: string; houseNumber: string; streetId: number }) => ({
            label: streetNumber.houseNumber,
            value: streetNumber.houseNumber,
          })
        );

        this.streetNumbersLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue lors de la récupération des numéros de rue');
        this.streetNumbersLoading = false;
      },
    });
  }

  public onSelectStreetNumber(event: { originalEvent: PointerEvent; value: string }): void {
    if (!event.value) {
      this.formSearch.patchValue({ streetNumber: null });
      return;
    }
    const selectedStreetNumber = this.streetNumbers.find(
      (streetNumber: { boxNumber: string; houseNumber: string; streetId: number }) => streetNumber.houseNumber === event.value
    );

    if (selectedStreetNumber) {
      this.formSearch.patchValue({ streetNumber: selectedStreetNumber.houseNumber });
    }
  }

  receive_selected(event): void {
    this.contact = event;
    this.router.navigateByUrl('/private/ic/contacts/details/' + this.contact.id);
  }

  public closeEditionMode(e): void {
    if (e) {
      this.editMode = false;
      this.contact = e;
      this.receive_selected(e);
    }
    if (e === 'deleted') {
      this.editMode = false;
    }
  }

  fullsearch(): void {
    if (this.searchString === '') {
      this.fullSearch = false;
    } else {
      this.fullSearch = true;
    }
  }

  onCreate(): void {
    const ref = this.dialogService.open(ContactNewComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        caller: 'contact',
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.router.navigateByUrl('/private/ic/contacts/details/' + value.id);
        }
      },
    });
  }

  // to keep to prevent click erro fct in the console
  getUserData(): void {
    console.info('to keep to prevent click erro fct in the console');
  }

  searchAdvanced(): void {
    this.spinner.show();
    this.active = false;
    this.noResults = false;
    this.searchString = ' ';
    this.searchObject = {
      nom: this.formSearch.value.nom !== null ? this.formSearch.value.nom.toLowerCase() : null,
      prenom: this.formSearch.value.prenom !== null ? this.formSearch.value.prenom.toLowerCase() : null,
      titre: this.formSearch.value.titre !== null ? this.formSearch.value.titre : null,
      tva: this.formSearch.value.tva !== null ? this.formSearch.value.tva.toUpperCase().replace(/\s/g, '') : null,
      nationalite: this.formSearch.value.nationalite,
      langueID: this.formSearch.value.langueID,
      email: this.formSearch.value.email,
      gsm: this.formSearch.value.gsm !== null ? this.formSearch.value.gsm.toLowerCase().replace(/\s/g, '') : null,
      cp: this.formSearch.value.cp !== null ? this.formSearch.value.cp.toLowerCase() : null,
      rue:
        this.formSearch.value.rue && this.formSearch.value.streetNumber
          ? `${this.formSearch.value.rue.toLowerCase()} ${this.formSearch.value.streetNumber}`
          : null,
      localite: this.formSearch.value.localite !== null ? this.formSearch.value.localite.toLowerCase() : null,
      contactTypeId: this.formSearch.value.contactTypeId,
    };
    this.contactsService.fetchSearchContacts(this.searchObject, 'iCourrier').subscribe({
      next: (res) => {
        this.spinner.hide();
        this.router.navigateByUrl('/private/ic/contacts');
        if (res.length > 0) {
          const filteredContacts = res.filter((x) => x.nePlusUtiliser === false || x.nePlusUtiliser === null);
          this.contacts = filteredContacts.map((item) => new Contact(item));
          this.contacts = _.sortBy(this.contacts, 'nom');
          this.searchString = '';
        } else {
          this.toastr.warning("Il n'y a pas de résultats pour votre recherche");
          this.noResults = true;
          this.contacts = [];
          this.searchString = '';
        }
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();
        this.toastr.warning("Il n'y a pas de résultats pour votre recherche");
        this.noResults = true;
        this.contacts = this.allcontacts;
        this.searchString = '';
      },
    });
    // this.searchString = '';
    this.openSearchModal = false;
  }

  reinit(): void {
    setTimeout(() => {
      this.searchString = null;
      this.searchObject = {
        nom: null,
        prenom: null,
        titre: null,
        tva: null,
        nationalite: null,
        langueID: null,
        email: null,
        gsm: null,
        cp: null,
        rue: null,
        localite: null,
        contactTypeId: null,
      };
      this.active = true;
      this.typeSociete = null;
      this.typeContact = null;
      this.formSearch.reset();
      this.noResults = false;
      this.contacts = this.contactsBACKUP;
    }, 500);
  }

  getContacts(params, scrollMode?: boolean, searchMode?: boolean): void {
    this.spinner.show();
    params.includeContactParent = true;
    this.contactsService.getLowInformationsContactsiCourrier(params).subscribe({
      next: (response) => {
        const temp = [];
        let temp_to_be_uniq = [];

        if (response.length > 0) {
          response.map((contact) => {
            contact.nom = contact.nom ? contact.nom.trim().replace(/[,/#!$%^*;:{}=\-_`~]/g, '') : '';
            contact.prenom = contact.prenom ? contact.prenom.trim().replace(/[,/#!$%^*;:{}=\-_`~]/g, '') : '';
            temp.push(new Contact(contact));
          });
        }

        if (temp.length > 0) {
          temp.map((item) => {
            this.contactsTypes.map((typeC) => {
              item['typeSocieteString'] = item.typeSociete ? 'oui' : 'non';
              if (item.typeContactID && item.typeContactID === typeC.value) {
                item.typeContactName = typeC.label;
              }
            });
          });
        }

        temp_to_be_uniq = temp;
        if (scrollMode) {
          this.allcontacts = this.allcontacts.concat(temp_to_be_uniq);
        } else {
          this.allcontacts = temp_to_be_uniq;
        }

        this.contacts = this.allcontacts.filter((x) => x.nePlusUtiliser === false || x.nePlusUtiliser === null);
        if (this.contacts.length === 0) {
          this.noResults = true;
        }
        if (!searchMode && !scrollMode) {
          this.contactsBACKUP = this.contacts;
        }

        this.triggerSearch = false;
        this.cd.markForCheck();
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();
      },
    });
  }

  receiveScrollE(e): void {
    if (e) {
      this.params = { ...this.params, ...e };
      this.getContacts(this.params, true);
    }
  }

  receiveSearchEvent(e): void {
    if (e) {
      this.getContacts(e, false, true);
    }
  }

  filterByTypeContact(typeContact): void {
    this.params.pageNumber = 1;
    if (typeContact !== null) {
      this.params.typeContactID = typeContact.id;
    } else {
      delete this.params.typeContactID;
    }
    this.getContacts(this.params, false, true);
  }

  filterBytypeSociete(typeSociete): void {
    this.params.pageNumber = 1;
    if (typeSociete !== null) {
      const typeS = typeSociete && typeSociete === 'oui' ? true : false;
      this.params.typeSociete = typeS;
    } else {
      delete this.params.typeSociete;
    }
    this.getContacts(this.params, false, true);
  }
}
